/**
 * The main api service
 */
import http from '@util/http';
import {incubator} from '@api/req';

export async function queryIncuSettleList(params) {
  return http.get(incubator.INCUBATOR_SETTLED_LIST, params);
}

export async function queryIncuSettleMy(params) {
  return http.get(incubator.INCUBATOR_SETTLED_MY, params);
}

export async function queryIncuSettleMyCheck(params) {
  return http.get(incubator.INCUBATOR_SETTLED_MY_CHECK, params);
}

export async function querySaveIncuSettled(params) {
  return http.post(incubator.INCUBATOR_SETTLED_SAVE, params);
}

export async function queryDeleteIncuSettled(params) {
  return http.get(incubator.INCUBATOR_SETTLED_DELETE, params);
}

export async function queryIncuSettledInfo(params) {
  return http.get(incubator.INCUBATOR_SETTLED_INFO, params);
}

export async function queryNextIncuSettled(params) {
  return http.get(incubator.INCUBATOR_SETTLED_NEXT, params);
}

export async function queryNextIncuSettledScan(params) {
  return http.post(incubator.INCUBATOR_SETTLED_NEXT_SCAN, params);
}

export async function queryNextIncuSettledArchive(params) {
  return http.post(incubator.INCUBATOR_SETTLED_NEXT_ARCHIVE, params);
}

export async function queryReturnIncuSettled(params) {
  return http.post(incubator.INCUBATOR_SETTLED_RETURN, params);
}

export async function queryCallbackIncuSettled(params) {
  return http.get(incubator.INCUBATOR_SETTLED_CALLBACK, params);
}

export async function queryIncuSettledEorkflow(params) {
  return http.get(incubator.INCUBATOR_SETTLED_WORKFLOW, params);
}

export async function queryDiscountList(params) {
  return http.get(incubator.SETTLED_WORKFLOW, params);
}

export async function queryRelateStation(params) {
  return http.post(incubator.STATION_SETTLED_RELATE, params);
}

export async function queryRenewBusinessInfo(params) {
  return http.get(incubator.RENEW_SETTLED_INFO, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/settled.js